import { Link } from 'react-router';
import type { MenuItem } from 'types/capi/plp';

import type { FacetSelection } from './Menus';

type Props = {
  item: MenuItem;
  menuId: string;
  onSelect: (selection: FacetSelection) => void;
};

export default function MenuOptionsListItem({ menuId, item, onSelect }: Props) {
  return (
    <>
      <Link
        data-cy="desktop-filter-option"
        id={item.text}
        to={item.path}
        className="flex items-center gap-2 p-4"
        onClick={() => onSelect(item)}
        {...(menuId === 'PRICE_MENU' && { rel: 'nofollow' })}
      >
        <input
          readOnly
          name={menuId}
          checked={item.active}
          className="cursor-pointer accent-forest"
          type="radio"
        />
        <label id={item.text} className="cursor-pointer text-sm">
          {item.text}
        </label>
      </Link>
      <hr className="border-gray-300" />
    </>
  );
}
